import React from 'react';
import '../css/home.css'; 
import SliderComponent from '../components/slider'; // Slider bileşenini içe aktarın
import { Helmet, HelmetProvider } from '@dr.pogodin/react-helmet';

const Home = () => (
  <div className="home-container mt-1">
 <HelmetProvider>
        <Helmet>
        <title>Boduroğlu Otomotiv | Kadosan Oto Servis</title>
    <meta
      name="description"
      content="Boduroğlu Otomotiv: Kadosan Dudullu'da profesyonel oto servis. Motor, kaporta, mekanik bakım, elektronik arıza tespiti ve daha fazlası."
    />
    <meta
      name="keywords"
      content="boduroğlu otomotiv, oto servis, kadosan araç bakım, dudullu araç tamiri, kaporta, motor arıza, fren tamiri, periyodik bakım"
    />
    <meta property="og:title" content="Boduroğlu Otomotiv | Kadosan Oto Servis" />
    <meta
      property="og:description"
      content="İstanbul Dudullu'da güvenilir oto servis hizmeti. Motor arıza, periyodik bakım, kaporta ve daha fazlası."
    />
    <meta property="og:image" content="https://bodurogluoto.com/logo.png" />
    <meta property="og:url" content="https://bodurogluoto.com/" />
    <meta property="og:type" content="website" />
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "AutoRepair",
        "name": "Boduroğlu Otomotiv",
        "image": "https://bodurogluoto.com/logo.png",
        "url": "https://bodurogluoto.com/",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Kadosan Dudullu",
          "addressLocality": "İstanbul",
          "addressCountry": "TR"
        },
        "description": "Kadosan Dudullu'da profesyonel oto servis. Motor, kaporta, mekanik bakım, elektronik arıza tespiti ve daha fazlası.",
        "telephone": "+905545996888"
      })}
    </script>
        </Helmet>
        </HelmetProvider>

    <div className="container mt-0">
      <h2 className="display-4 text-center mb-4">
        <i className="fas fa-car-repair me-2"></i> 
        Boduroğlu Otomotiv Servisine Hoşgeldiniz
      </h2>
      
      <p className="lead text-center mb-4">
        <i className="fas fa-tools me-2"></i>
        Boduroğlu Otomotiv olarak, deneyimli ekibimiz ve son teknoloji ekipmanlarımızla aracınızın tüm bakım ve onarım ihtiyaçlarını karşılıyoruz. 
        Müşteri memnuniyetini ön planda tutarak, güvenilir ve hızlı hizmet sunuyoruz.
      </p>
      <SliderComponent />

    
      <div className="services-section text-center my-5">
        <h3 className="mb-4">
          <i className="fas fa-wrench me-2"></i>
          Hizmetlerimiz
        </h3>
        <div className="row">
          {[
            "Periyodik Bakım Hizmeti",
            "Mekanik Sistem Onarımları",
            "Yağ Değişimi ve Filtre Değişimi",
            "Motor Arıza Teşhisi ve Tamiri",
            "Profesyonel Klima Servisi",
            "Elektronik Sistem Arıza Teşhisi",
            "Frenleme Sistem Bakımı ve Onarımı",
            "Lamba ve Aydınlatma Kontrolleri",
            "Kaporta Boya Servisi"
          ].map((service, index) => (
            <div className="col-md-4 mb-3" key={index}>
              <div className="service-card shadow-sm p-3">
                <i className="fas fa-check-circle service-icon"></i>
                <p>{service}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="text-center mt-5">
        <a href="/hakkimizda" className="btn btn-custom btn-lg">
          <i className="fas fa-info-circle me-2"></i> 
          Hakkımızda Daha Fazla Bilgi
        </a>
      </div>
    </div>
  </div>
);

export default Home;
